import { animate } from 'motion/react';
import { useEffect, useRef, useState } from 'react';
import type { UseAnimatedTextProps } from './useAnimatedText.types';

const delimiter = /[\s\S]{1,3}/g;

export function useAnimatedText(props: UseAnimatedTextProps) {
  const { text, enabled } = props;
  const [cursor, setCursor] = useState(0);
  const prevTextRef = useRef(text);
  const cursorRef = useRef(0);

  useEffect(() => {
    if (!enabled) {
      prevTextRef.current = text;
      cursorRef.current = 0;
      return;
    }

    const prevText = prevTextRef.current;
    const startingCursor = text.startsWith(prevText) ? cursorRef.current : 0;
    prevTextRef.current = text;

    const chunks = text.match(delimiter) || [];
    const controls = animate(startingCursor, chunks.length, {
      duration: 1.5,
      ease: 'linear',
      onUpdate(latest) {
        const val = Math.floor(latest);
        cursorRef.current = val;
        setCursor(val);
      },
    });

    return () => controls.stop();
  }, [text, enabled]);

  if (!enabled) return text;

  const chunks = text.match(delimiter) || [];
  return chunks.slice(0, cursor).join('');
}
